export default "__VITE_ASSET__DyvG7Tem__"